import { IconName } from '@clinic-monorepo/clinic-icon';

import { ExternalSites } from '../../../../../constants/ExternalSites';

/** 外部サイトへ遷移するカード1枚分の定義 */
export type ExternalDivisionLink = {
  /** カードに表示する名前 */
  name: string;
  /** カード内の補足説明（SPでは表示されない） */
  description?: string;
  icon: IconName;
  /** 遷移先URL。別タブで開く */
  url: string;
};

/**
 * 診療科ではないが、診療科選択画面にクリニックと同じ体裁で並べたい外部リンクのまとまり。
 *
 * 見出し（`name`）＋カード（`links`）という構造はクリニックのセクションと共通で、
 * `insertAfterClinicName` で表示位置だけを宣言的に指定する。
 */
export type ExternalDivision = {
  /** 見出し。クリニック名と同じ位置に表示される */
  name: string;
  /**
   * このクリニック名のセクションの直後に差し込む。
   * 未指定、または該当するクリニックが無い場合は一覧の末尾に置かれる。
   */
  insertAfterClinicName?: string;
  links: ExternalDivisionLink[];
};

/**
 * 診療科選択画面に表示する外部リンクセクションの一覧。
 * 増やす場合はこの配列に足すだけでよい。
 */
export const ExternalDivisions: ExternalDivision[] = [
  {
    name: 'INTERNATIONAL DIVISION',
    // DENTAL CLINIC TEN SHIBUYA と CLINIC TEN SHIBUYA の間に表示する
    insertAfterClinicName: 'DENTAL CLINIC TEN SHIBUYA',
    links: [
      {
        name: 'FOR VISITORS',
        description: 'English information for international patients',
        icon: 'user',
        url: ExternalSites.EnglishLandingPage,
      },
    ],
  },
];
